export default __webpack_public_path__ + "static/media/geo.544e97c2.svg";